import Bugsnag from "@bugsnag/js";

export interface NotifyErrorContext {
  endpoint?: string;
  statusCode?: number;
  component?: string;
  action?: string;
}

export const notifyError = (error: unknown, context?: NotifyErrorContext) => {
  console.error(error);
  if (Bugsnag.isStarted()) {
    const err = error instanceof Error ? error : new Error(String(error));
    Bugsnag.notify(err, event => {
      if (context?.endpoint || context?.statusCode) {
        event.addMetadata("request", {
          endpoint: context.endpoint,
          statusCode: context.statusCode,
        });
      }
      if (context?.component || context?.action) {
        event.addMetadata("ui", {
          component: context.component,
          action: context.action,
        });
      }
    });
  }
};
